import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import CloseIcon from "assets/svgs/close-btn.svg";
import RichText from "components/rich-text";
import * as styles from "./style.mod.scss";
import getImagePath from "helpers/get-image-path";

const ShortInfo = ({ content }) => {
  if (!content?.shortInfo) return<></>;
  const shortInfo = content?.shortInfo;
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleShow = () => setOpen(true);

  return (
    <div className={styles.infoSection}>
      <p className={styles.infoTitle}>{shortInfo?.title}</p>
      <p className={styles.infoDescription}>{shortInfo?.description} <span className={styles.infoLinkableText} onClick={handleShow}>{shortInfo?.linkableText}</span></p>
      <Modal show={open} onHide={handleClose} className={styles.shortInfoModal}>
        <CloseIcon className={`${styles.modalClose} ${styles.modalCloseDesktop}`} onClick={handleClose} />
        <Modal.Body>
          <div className={styles.shortInfoBody}>
            <div className={shortInfo?.alternateText ? `${styles.alternateTextStyle}  ${styles.shortInfoContent}`:styles.shortInfoContent}>
              <div className={styles.shortInfoText}>
                <RichText
                  blocks={shortInfo?.modal?.content}
                />
              </div>
              <div className={`${styles.shortInfoImage} ${(styles.fullWidthImage) ? styles.shortInfoImageCover : ""}`}>
                <img className={styles.shortInfoImageMobile} srcSet={getImagePath(shortInfo?.modal?.image, true)} alt={shortInfo?.modal?.image?.alt} />
                <img className={styles.shortInfoImageDesktop} srcSet={getImagePath(shortInfo?.modal?.image, true)} alt={shortInfo?.modal?.image?.alt} />
              </div>
            </div>
          </div>
        </Modal.Body>
        <div className={styles.modalCloseContainer}>
          <CloseIcon className={`${styles.modalClose} ${styles.modalCloseResponsive}`} onClick={handleClose} />
        </div>
      </Modal>
    </div>
  );
};

export default ShortInfo;